module.exports = __webpack_public_path__ + "c431ef4df4c839a5c360e5b88701be1e.svg";